"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Star = function Star(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " ").concat(animation)
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.368 16.028a.836.836 0 01-.4-.1l-2.956-1.556-2.956 1.556a.866.866 0 01-.908-.064.847.847 0 01-.34-.844l.564-3.292L3.98 9.396a.864.864 0 01.476-1.472l3.304-.48 1.48-2.996a.851.851 0 01.772-.48c.332 0 .628.184.772.48l1.48 2.996 3.304.48a.852.852 0 01.696.588.848.848 0 01-.22.884l-2.392 2.332.564 3.292a.857.857 0 01-.344.844.826.826 0 01-.504.164zM4.9 8.884l2.232 2.172c.204.2.296.484.248.764l-.528 3.072 2.756-1.452a.866.866 0 01.804 0l2.756 1.448-.528-3.068a.863.863 0 01.248-.764L15.12 8.88l-3.084-.448a.856.856 0 01-.648-.472l-1.38-2.792-1.38 2.796a.873.873 0 01-.648.472l-3.08.448zm7.396-1.368h.008-.008zM10.148 4.9c-.004 0-.004 0 0 0z",
    fill: color
  }));
};
var _default = exports["default"] = Star;